<template>
  <div class="menu-container w_100p flex flex_w_w">
    <div v-for="item in list" :key="item.name" class="p_lr_10 cursor_p btn" @click="onClick(item)">
      <div class="c_9fa3a6 f_s_14 p_10">{{item.name}}</div>
      <div class="w_208 of_h">
        <img :src="item.img" class="w_208 b_c_0000000d scale12" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DuiDropdownMenu",
  props: {
    list: {
      type: Array
    }
  },
  methods: {
    onClick(item) {
      if (item.id && item.template) {
        this.$router.push({
          path: "/" + item.template + "/" + item.id
        });
        this.$emit("success");
      }
    }
  }
};
</script>

<style>
.menu-container {
  opacity: 1;
  transition: opacity 0.3s ease;
  z-index: 1;
}
.w_208 {
  width: 108px;
}
</style>